import { USDI_API_EUROPE_WEST_URL } from '../configs/config';

const BASE = USDI_API_EUROPE_WEST_URL;

// The cash_received endpoint currently executes the Squads release on-chain
// before responding, which can take a while or hang entirely (Cloud Run
// timeout). Abort client-side so the UI is never stuck on "Submitting..."
// forever; the caller refetches status afterwards either way.
const REQUEST_TIMEOUT_MS = 60000;

async function postJson(path, body) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);
    let res;
    try {
        res = await fetch(`${BASE}${path}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
            signal: controller.signal,
        });
    } catch (err) {
        if (err.name === 'AbortError') {
            throw new Error(
                'The server took too long to respond. Your request may still be processing — the status will update automatically once it completes.'
            );
        }
        throw err;
    } finally {
        clearTimeout(timer);
    }
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        throw new Error(data.error || data.message || 'Request failed');
    }
    return data;
}

export function submitCashReceived(txsId, walletAddress, cashDeliveryReceivedTime) {
    return postJson('/cash_redeem/cash_received', {
        txs_id: txsId,
        wallet_address: walletAddress,
        cash_delivery_received_time: cashDeliveryReceivedTime,
    });
}

export function submitC2cDispute(txsId, walletAddress, reason = '') {
    return postJson('/cash_redeem/dispute', {
        txs_id: txsId,
        wallet_address: walletAddress,
        reason,
    });
}

export function fetchAdminC2cDisputes(status = 'open') {
    return fetch(`${BASE}/admin/c2c_disputes?status=${encodeURIComponent(status)}`).then(async (res) => {
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || 'Failed to load disputes');
        return data.disputes || [];
    });
}

export function resolveAdminC2cDispute(txsId, resolution, notes = '') {
    return postJson(`/admin/c2c_disputes/${txsId}/resolve`, {
        resolution,
        notes,
        admin_user: 'admin',
    });
}
